<template>
  <div class="cart">
    <isProduct v-if="is_show" />
    <noProduct v-else />
  </div>
</template>

<script>
  import isProduct from '../components/IsProduct.vue';
  import noProduct from '../components/NoProduct.vue';

  export default {
    name: 'Cart',
    components: {
      isProduct,
      noProduct,
    },
    data: () => ({
      userId: '',
      token: '',
      show_page: true,
    }),
    computed: {
      is_show() {
        const accessToken = sessionStorage.getItem('accessToken');
        const user_uuid = sessionStorage.getItem('user_uuid');
        if (accessToken !== null && user_uuid !== null) {
          if (
            this.$store.state.putcartlist.putcartData !== undefined &&
            this.$store.state.putcartlist.putcartData.length !== 0
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    created() {
    },
    methods: {
      get_Cart() {
        if (
          this.$store.state.cartlist.cartData !== undefined &&
          this.$store.state.cartlist.cartData.length !== 0
        ) {
          this.show_page = true;
        } else {
          this.show_page = false;
        }
      }
    },
    mounted() {
    },
    beforeDestroy() {
    },
  };
</script>